import OurProjectVerticalList from "../../our-project-vertical/List";
import { useCorporateDesignProjects } from "../../useHook";
import { SystemPermissions } from "../../../../Utils/permissionAccess";

function OurProjectCorporateDesignList() {
  return (
    <OurProjectVerticalList
      title="Manage Corporate Design Project"
      basePath="/our-project-corporate-design"
      sourceType="corporate_design_project"
      similarPermission={SystemPermissions.ManageCorporateDesignProject.ADD_SIMILAR}
      useProjectsHook={useCorporateDesignProjects}
    />
  );
}

export default OurProjectCorporateDesignList;
